import { useState } from 'react';
import styles from './styles.module.scss';
import ScrollToTopOnMount from '@/ScrollToTop';
import PageContainer from 'components/common/PageContainer';
import { t } from 'i18next';
import PageTitle from 'components/common/Layout/PageTitle';
import { Form, Formik } from 'formik';
import FormikTextField from 'components/InputsField/formikInputs/FormikTextField';
import Button from 'components/common/Button';
import { MESSENGER_TYPE, SOCIAL_NETWORKS } from 'helpers/messengers';
import MessengerLink from 'components/common/MessengerLink';
import { FormikTextareaField } from 'components/InputsField/formikInputs/FormikTextareaField';
import { ContactUsService } from 'service/ContactUsService';
import * as Yup from 'yup';
import { ERROR_PLACE } from 'components/InputsField/InputError';

function Contacts() {
  const [success, setSuccess] = useState(false);
  const currentPage = t('header.contacts');
  const messengers = [
    { login: 'support@blago.pro', type: MESSENGER_TYPE.email },
    { login: '+375447772749', type: MESSENGER_TYPE.viber },
    { login: 'blagoproby', type: MESSENGER_TYPE.telegram },
    { login: '+375447772749', type: MESSENGER_TYPE.whatsapp },
  ];
  const socialNetworks = [
    //      {login: "empty", type: MESSENGER_TYPE.viber},
    { login: 'blago_pro', type: SOCIAL_NETWORKS.telegram },
    //      {login: "empty", type: MESSENGER_TYPE.whatsapp},
    { login: '@blagopro', type: SOCIAL_NETWORKS.youtube },
    { login: '@blagoproby', type: SOCIAL_NETWORKS.tiktok },
    { login: 'blago_pro', type: SOCIAL_NETWORKS.instagram },
  ];
  const handleSubmit = (values, { resetForm }) => {
    ContactUsService.sendMessage({
      email: values.email,
      theme: 'Feedback from contacts',
      name: values.name,
      message: values.message,
    })
      .then(() => {
        setSuccess(true);
        resetForm();
        setTimeout(() => {
          setSuccess(false);
        }, 3000);
      })
      .catch((e) => {
        if (e.response && e.response.data && e.response.data.errors) {
          console.log(e.response.data.errors);
        }
      });
  };
  const validationSchema = Yup.object({
    name: Yup.string()
      .max(32, t('contacts.form.validation.name_max'))
      .min(3, t('contacts.form.validation.name_min'))
      .required(t('contacts.form.validation.name_required')),
    email: Yup.string()
      .email(t('contacts.form.validation.email_invalid'))
      .required(t('contacts.form.validation.email_required')),
    message: Yup.string()
      .max(128, t('contacts.form.validation.message_max'))
      .min(3, t('contacts.form.validation.message_min'))
      .required(t('contacts.form.validation.message_required')),
  });

  return (
    <>
      <ScrollToTopOnMount />
      <PageContainer>
        <div>
          <div>
            <PageTitle>{currentPage}</PageTitle>
          </div>
        </div>
        <div className={styles.container}>
          <div className={styles.container__contactData}>
            <div className={styles.container__section}>
              <h3>{t('contacts.proposal')}</h3>
            </div>
            <div className={styles.container__section}>
              <p>{t('contacts.phone_number')}</p>
              <p>
                <a href="tel:+375447772749">+375 (44) 777-27-49</a>
              </p>
            </div>

            <div className={styles.container__section}>
              <p>{t('contacts.email')}</p>
              <p>
                <a href="mailto:info@blago.pro">info@blago.pro</a>
              </p>
            </div>

            <div className={styles.container__section}>
              <p>{t('contacts.legal_address')}</p>
              <p>ООО "Каргопати", УНП 591761639, 231818, Республика Беларусь Гродненская область Слонимский район Озгиновичский сельсовет д. Чемеры</p>
            </div>

            <div className={styles.container__section}>
              <p>{t('contacts.support')}</p>
              <div className={styles.messengers}>
                {messengers.map((item, index) => (
                  <div key={index} className={styles.messenger}>
                    <MessengerLink item={item} size={'normal'} />
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.container__section}>
              <p>{t('contacts.social_networks')}</p>
              <div className={styles.messengers}>
                {socialNetworks.map((item, index) => (
                  <div key={index} className={styles.messenger}>
                    <MessengerLink item={item} size={'normal'} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles.container__form}>
            <Formik
              initialValues={{ name: '', email: '', message: '' }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Form>
                <h3 className={styles.container__form__name}>{t('contacts.form.form_name')}</h3>
                <FormikTextField
                  name="name"
                  placeholder={t('contacts.form.name')}
                  wrapperClassName={styles['field--with-margin']}
                  errorMode={ERROR_PLACE.center}
                />
                <FormikTextField
                  name="email"
                  placeholder={t('contacts.form.email')}
                  wrapperClassName={styles['field--with-margin']}
                  errorMode={ERROR_PLACE.center}
                />
                <FormikTextareaField
                  name="message"
                  placeholder={t('contacts.form.message')}
                  wrapperClassName={styles['field--with-margin']}
                  errorMode={ERROR_PLACE.center}
                  maxLength={128}
                  showCharCounter
                />
                {success ? (
                  <span className={styles.successMessage}>{t('contactUs.success')}</span>
                ) : (
                  <Button type="submit" className={styles.button}>
                    {t('contacts.form.submit')}
                  </Button>
                )}
              </Form>
            </Formik>
          </div>
        </div>
      </PageContainer>
    </>
  );
}

export default Contacts;
